import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-progress-indicator-popup',
  templateUrl: './progress-indicator-popup.component.html',
  styleUrls: ['./progress-indicator-popup.component.scss']
})
export class ProgressIndicatorPopupComponent implements OnInit, OnDestroy {
  @Input() progressData: any;

  total: number;
  done: number;
  errorMessage: string;
  title: string;
  actionString: string;
  successMessage: string;
  updateSubject: Subject<any>;
  progress: number;
  currentStep: number;
  totalStep: number;
  stepTitle: string;
  subscription: Subscription = new Subscription();
  stepFeedbackErrorMsg: string;
  stepFeedbackWarningMsg: string;
  stepFeedbackSuccessMsg: string;
  untrackable: boolean;

  constructor(public activeModal: NgbActiveModal) {
    console.log("Inside progress dialog constructor");
    window.addEventListener('keyup', (event) => {
      if (this.successMessage && event.key === "Escape") {
        this.closeModal(event);
      }
    });
  }

  ngOnInit() {
    console.log("Inside progress dialog ngOnInit", { ...this.progressData });
    if (this.progressData) {
      this.total = this.progressData.total;
      this.done = this.progressData.done;
      this.untrackable = this.progressData.untrackable;
      this.errorMessage = this.progressData.errorMessage;
      this.title = this.progressData.title;
      if (this.progressData.step) {
        this.currentStep = this.progressData.step.currentStep;
        this.totalStep = this.progressData.step.totalStep;
        this.stepTitle = this.progressData.step.stepTitle;
      }
      if (this.progressData.stepFeedback) {
        this.stepFeedbackErrorMsg = this.progressData.stepFeedback.errorMessage;
        this.stepFeedbackWarningMsg = this.progressData.stepFeedback.warningMessage;
        this.stepFeedbackSuccessMsg = this.progressData.stepFeedback.successMessage;
      }
      this.actionString = this.progressData.actionString;
      this.successMessage = this.progressData.successMessage;
      this.updateSubject = this.progressData.updateSubject;
      if (!this.untrackable) {
        this.progress = (this.done / this.total) * 100;
      }
      this.subscription = this.updateSubject.subscribe(data => {
        console.log("Data updated", data);
        this.total = data.total;
        this.done = data.done;
        this.untrackable = this.progressData.untrackable;
        this.errorMessage = data.errorMessage;
        this.title = data.title;
        if (data.step) {
          this.currentStep = data.step.currentStep;
          this.totalStep = data.step.totalStep;
          this.stepTitle = data.step.stepTitle;
        }
        if (data.stepFeedback) {
          this.stepFeedbackErrorMsg = this.progressData.stepFeedback.errorMessage;
          this.stepFeedbackWarningMsg = this.progressData.stepFeedback.warningMessage;
          this.stepFeedbackSuccessMsg = this.progressData.stepFeedback.successMessage;
        }
        this.actionString = data.actionString;
        this.successMessage = data.successMessage;
        if (!this.untrackable) {
          this.progress = (this.done / this.total) * 100;
        }
      });
    }
    else {
      console.log("No progress data yet");
    }
  }

  closeModal(event) {
    // the timeout prevents the keyboard event to be sent to the parent. 
    // preventdefault did not work in this case
    setTimeout(() => {
      this.activeModal.close();
      event.preventDefault();
    }, 300);
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

}
